<section class="rb-group">
  <header class="rb-group__header">
    <div class="rb-group__title">
      <span class="rb-group__label">Match</span>

      <mat-button-toggle-group class="rb-comb" [value]="model?.condition === 'OR' ? 'ANY' : 'ALL'"
        (change)="changeCondition($event.value)">
        <mat-button-toggle value="ALL" aria-label="Match all">ALL</mat-button-toggle>
        <mat-button-toggle value="ANY" aria-label="Match any">ANY</mat-button-toggle>
      </mat-button-toggle-group>

      <span class="rb-group__suffix">of the following</span>
      <span class="rb-comb-hint">({{ model?.condition === 'OR' ? 'OR' : 'AND' }})</span>
    </div>

    <div class="rb-group__meta mr-4">
      <span class="rb-meta">{{ (model?.rules || []).length }} items</span>
    </div>
  </header>

  <div class="rb-group__body">
    <!-- rules + nested groups render here -->
    <formly-field [field]="field.fieldGroup[1]"></formly-field>

    @if ((model?.rules || []).length === 0) {
      <div class="rb-empty">
        Start by adding a <b>Condition</b> or a <b>Group</b>.
      </div>
    }

    <!-- only two add buttons -->
    <div class="rb-addbar">
      <button type="button" mat-stroked-button (click)="addRule()">
        <mat-icon>add</mat-icon> Condition
      </button>
      <button type="button" mat-stroked-button (click)="addRuleset()">
        <mat-icon>playlist_add</mat-icon> Group
      </button>
    </div>
  </div>


</section>
